import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_VIDEO_QUALITY, MEDIA_PERMISSIONS } from "../constants/CallSettingConstants";
import { DEFAULT_VIRTUAL_BACKGROUND_IMAGES, VIRTUAL_BACKGROUND } from "../constants/VirtualBackgroundConstant";
import storage from "../services/storage";
import { LOCAL_STORAGE_KEYS } from "../constants/Constants";

const getVirtualBackgroundImages = () => {
    const virtualBackgroundLocalStoarageImageUrl = getVirtualBackgroundLocalImageUrl();
    if (virtualBackgroundLocalStoarageImageUrl) {
        const localStorageVirtualBackgroundImageData = { id: VIRTUAL_BACKGROUND.LOCAL_IMAGE_ID, image: virtualBackgroundLocalStoarageImageUrl };
        return [localStorageVirtualBackgroundImageData, ...DEFAULT_VIRTUAL_BACKGROUND_IMAGES];
    } else {
        return DEFAULT_VIRTUAL_BACKGROUND_IMAGES;
    }
};

const getVirtualBackgroundSelectedImageId = () => {
    const selectedVirtualBackgroundImageId = storage.get(LOCAL_STORAGE_KEYS.SELECTED_VIRTUAL_BACKGROUND_IMAGE_ID);
    return selectedVirtualBackgroundImageId || VIRTUAL_BACKGROUND.NONE_EFFECT_ID;
};

const getVirtualBackgroundLocalImageUrl = () => {
    const virtualBackgroundLocalImageUrl = storage.get(LOCAL_STORAGE_KEYS.VIRTUAL_BACKGROUND_UPLOAD_IMAGE);
    return virtualBackgroundLocalImageUrl || null;
};

const initialState = {
    isCameraExist: false,
    isMicExist: false,
    cameraPermission: MEDIA_PERMISSIONS.PROMPT,
    audioPermission: MEDIA_PERMISSIONS.PROMPT,
    cameraDevices: [],
    audioDevices: [],
    speakerDevices: [],
    currentCameraDevice: {},
    currentAudioDevice: {},
    currentSpeakerDevice: {},
    currentSelectedVideoQuality: DEFAULT_VIDEO_QUALITY,
    videoQualityResolutionList: [],
    videoQualityResolutionParams: {},
    isFrontCameraSelected: false,
    workingCam: false,
    videoFacingmode: false,
    virtualBackgroundLocalImageUrl: getVirtualBackgroundLocalImageUrl(),
    virtualBackgroundImages: getVirtualBackgroundImages(),
    isRemoveVirtualBackgroundUploadImage: false,
    selectedVirtualBackgroundImageId: getVirtualBackgroundSelectedImageId(),
    startCallSettingLocalVideo: false,
    isStartCallSettingLoader: false,
};

const callSettingReducerSlice = createSlice({
    name: "callSettingReducer",
    initialState,
    reducers: {
        setIsCameraExist(state, action) {
            state.isCameraExist = action.payload;
        },
        setIsMicExist(state, action) {
            state.isMicExist = action.payload;
        },
        setCameraPermission(state, action) {
            state.cameraPermission = action.payload;
        },
        setAudioPermission(state, action) {
            state.audioPermission = action.payload;
        },
        setCameraDevices(state, action) {
            state.cameraDevices = action.payload;
        },
        setAudioDevices(state, action) {
            state.audioDevices = action.payload;
        },
        setSpeakerDevices(state, action) {
            state.speakerDevices = action.payload;
        },
        setCurrentCameraDevice(state, action) {
            state.currentCameraDevice = action.payload;
        },
        setCurrentAudioDevice(state, action) {
            state.currentAudioDevice = action.payload;
        },
        setCurrentSpeakerDevice(state, action) {
            state.currentSpeakerDevice = action.payload;
        },
        setCurrentSelectedVideoQuality(state, action) {
            state.currentSelectedVideoQuality = action.payload;
        },
        setVideoQualityResolutionList(state, action) {
            state.videoQualityResolutionList = action.payload;
        },
        setVideoQualityResolutionParams(state, action) {
            state.videoQualityResolutionParams = action.payload;
        },
        setIsFrontCameraSelected(state, action) {
            state.isFrontCameraSelected = action.payload;
        },
        setWorkingCam(state, action) {
            state.workingCam = action.payload;
        },
        setVideoFacingmode(state, action) {
            state.videoFacingmode = action.payload;
        },
        setVirtualBackgroundLocalImageUrl(state, action) {
            state.virtualBackgroundLocalImageUrl = action.payload;
        },
        setVirtualBackgroundImages(state, action) {
            state.virtualBackgroundImages = action.payload;
        },
        setIsRemoveVirtualBackgroundUploadImage(state, action) {
            state.isRemoveVirtualBackgroundUploadImage = action.payload;
        },
        setSelectedVirtualBackgroundImageId(state, action) {
            state.selectedVirtualBackgroundImageId = action.payload;
        },
        setStartCallSettingLocalVideo(state, action) {
            state.startCallSettingLocalVideo = action.payload;
        },
        setIsStartCallSettingLoader(state, action) {
            state.isStartCallSettingLoader = action.payload;
        },
        resetCallSettingReducer() {
            return initialState;
        },
    },
});

export const {
    setIsCameraExist,
    setIsMicExist,
    setCameraPermission,
    setAudioPermission,
    setCameraDevices,
    setAudioDevices,
    setSpeakerDevices,
    setCurrentCameraDevice,
    setCurrentAudioDevice,
    setCurrentSpeakerDevice,
    setCurrentSelectedVideoQuality,
    setVideoQualityResolutionList,
    setVideoQualityResolutionParams,
    setIsFrontCameraSelected,
    setWorkingCam,
    setVideoFacingmode,
    setVirtualBackgroundLocalImageUrl,
    setVirtualBackgroundImages,
    setIsRemoveVirtualBackgroundUploadImage,
    setSelectedVirtualBackgroundImageId,
    setStartCallSettingLocalVideo,
    setIsStartCallSettingLoader,
    resetCallSettingReducer,
} = callSettingReducerSlice.actions;

export default callSettingReducerSlice.reducer;
